import { render, staticRenderFns } from "./JudgeRubricCard.vue?vue&type=template&id=fca66596&scoped=true&"
import script from "./JudgeRubricCard.vue?vue&type=script&lang=js&"
export * from "./JudgeRubricCard.vue?vue&type=script&lang=js&"
import style0 from "./JudgeRubricCard.vue?vue&type=style&index=0&id=fca66596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca66596",
  null
  
)

export default component.exports